import React from 'react';
import PropTypes from 'prop-types';
import './Typography.scss';

const Typography = ({
    variant = 'body1',
    component,
    children,
    className = '',
    color = 'text',
    align = 'left',
    ...props
}) => {
    const Component = component || getDefaultComponent(variant);
    const typographyClasses = [
        'typography',
        `typography--${variant}`,
        `typography--${color}`,
        `typography--${align}`,
        className
    ].filter(Boolean).join(' ');

    return (
        <Component className={typographyClasses} {...props}>
            {children}
        </Component>
    );
};

const getDefaultComponent = (variant) => {
    switch (variant) {
        case 'h1':
            return 'h1';
        case 'h2':
            return 'h2';
        case 'h3':
            return 'h3';
        case 'h4':
            return 'h4';
        case 'h5':
            return 'h5';
        case 'h6':
            return 'h6';
        case 'subtitle1':
        case 'subtitle2':
            return 'h6';
        case 'body1':
        case 'body2':
        default:
            return 'p';
    }
};

Typography.propTypes = {
    variant: PropTypes.oneOf([
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        'subtitle1', 'subtitle2',
        'body1', 'body2',
        'button', 'caption', 'overline'
    ]),
    component: PropTypes.elementType,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    color: PropTypes.oneOf(['text', 'primary', 'secondary', 'error', 'warning', 'info', 'success']),
    align: PropTypes.oneOf(['left', 'center', 'right', 'justify']),
};

export default Typography; 